import { cn } from '@/lib/cn'

export interface LogoProps {
  /** 'dark' — na granatowym sidebarze, 'light' — na jasnym tle. */
  tone?: 'dark' | 'light'
  /** Druga linia — nazwa kancelarii z /api/me/context. */
  firmName?: string
  className?: string
}

/** Znak „AM" + logotyp ActaModus (Spectral) — sidebar i ekran logowania. */
export function Logo({ tone = 'dark', firmName, className }: LogoProps) {
  // w mockupie druga linia to sama nazwa („MAZUR & PARTNERZY"), bez słowa „Kancelaria"
  const subtitle = firmName?.replace(/^kancelaria\s+/i, '')
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <span className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-[2px] bg-gold font-display text-[18px] font-semibold tracking-tight text-navy-900">
        AM
      </span>
      <span className="min-w-0">
        <span
          className={cn(
            'block font-display text-[17px] font-semibold leading-tight',
            tone === 'dark' ? 'text-white' : 'text-ink',
          )}
        >
          ActaModus
        </span>
        {subtitle ? (
          <span
            className={cn(
              'block truncate text-[10.5px] font-semibold uppercase leading-tight tracking-[0.11em]',
              tone === 'dark' ? 'text-sidebar-muted' : 'text-muted',
            )}
          >
            {subtitle}
          </span>
        ) : null}
      </span>
    </div>
  )
}
